
import html from '../img/html.png'
import css from '../img/css.png'
import javascript from '../img/javascript.png'
import react from '../img/react.png'
import java from '../img/java.png'
import python from '../img/python.png'
import c from '../img/c#.png'
import git from '../img/git.png'


const data = [
  {
    category: "HTML",
    img: html,
    questions: [
      {
        question: "HTML é uma linguagem de...",
        options: ["Criação", "Programação", "Exclusão", "Formatação"],
        answer: "Formatação",
        tip: "Formatação",
      },
      {
        question: "Para deixar a página com o fundo azul claro, qual tag deve ser inserida?",
        options: ["<body style='background-color:lightblue'>", "<body style='backcolor:blue'>", "<body style='backcolor:#88AAFF'>", "<body style='backgroundColor:lightblue'>"],
        answer: "<body style='background-color:lightblue'>",
        tip: "<body style='backgroundColor:lightblue'>",
      },
      {
        question: "O conteúdo de uma página feita em estilo incorporado fica entre as tags:",
        options: ["<head></head>", "<incorp></incorp>", "<style></style>", "</title><style>"],
        answer: "<style></style>",
        tip: "É uma tag de uma letra apenas",
      },
      {
        question: "Qual tag cria um parágrafo?",
        options: ["<p>", "<h1>", "<text>", "<ul>"],
        answer: "<p>",
        tip: "É uma tag de uma letra apenas",
      },
      {
        question: "Qual atributo adiciona um link para a tag a?",
        options: ["alt", "href", "src", "link"],
        answer: "href",
        tip: "Hyperlink Reference",
      },
      {
        question: "As listas não ordenadas tem a tag de:",
        options: ["<ol>", "<ul>", "<li>", "<list>"],
        answer: "<ul>",
      },
      {
        question: "Qual atributo deixa o input obrigatório?",
        options: ["placeholder", "value", "required", "maxlength"],
        answer: "required",
      },
      {
        question: "A tag semântica indicada para rodapés é a:",
        options: ["div", "main", "section", "footer"],
        answer: "footer",
      },
      {
        question: "O que faz a tag TR?",
        options: ["define um coluna", "define uma linha", "define colunas e linhas", "define o titulo de uma tabela"],
        answer: "define uma linha",
      },
      {
        question: "Qual metodo usado para carregar uma funcão quando a página for inicalizada no HTML?",
        options: ["onload", "onboard", "OnLoad", "onClic"],
        answer: "onload",
      },

    ],
  },
  {
    category: "CSS",
    img: css,
    questions: [
      {
        question: "Qual regra altera a cor de um elemento?",
        options: ["color", "background-color", "font-size", "transition"],
        answer: "color",
        // tip: "Cor em inglês",
      },
      {
        question: "Qual a sintaxe para inserir um comentário CSS?",
        options: ["// Este é um comentário", "/* Este é um comentário */", "<!-- Este é um comentário -->", "<! Este é um comentário >"],
        answer: "/* Este é um comentário */",
        // tip: "Cor em inglês",
      },
      {
        question: "Qual regra define parágrafos em negrito?",
        options: ["p {font-weight: bold;}", "p {text-style: bold;}", "p {fontWeight: bold;}", "p {font-decoration:bold;}"],
        answer: "p {font-weight: bold;}",
        // tip: "Cor em inglês",
      },
      {
        question: "Qual propriedade define a família de fontes?",
        options: ["family-font", "font", "fontFamily", "font-family"],
        answer: "font-family",
        // tip: "Cor em inglês",
      },
      {
        question: "Para aumentar a fonte de um elemento utilizamos:",
        options: ["font", "text-transform", "font-size", "hover"],
        answer: "font-size",
      },
      {
        question: "A posição que deixa um elemento fixo é a:",
        options: ["static", "absolute", "fixed", "relative"],
        answer: "fixed",
      },
      {
        question: "Qual tag e usada para mudar a cor da fonte:",
        options: ["color", "white", "red", "font-sizer"],
        answer: "color",
      },
      {
        question: "Qual tag e usada para mudar a cor de fundo da pagina:",
        options: ["backgroundSizerColor", "Color", "backgroundColorTwo", "backgroundColor"],
        answer: "backgroundColor",
      },
      {
        question: "Como declarar corretamente um elemento, criado através de um ID que possui o nome de 'divView' no CSS ",
        options: [".divView", "#divView", "#div.View", "[#divView]"],
        answer: "#divView",
      },
      {
        question: "Comando para retirar os caracteres especiais de uma lista e?",
        options: ["list-style: none;", "style-type: none;", "list-style-type: null", "list-style-type: none"],
        answer: "list-style-type: none",
      },
    ],
  },
  {
    category: "JavaScript",
    img: javascript,
    questions: [
      {
        question: "O que é Vanilla JavaScript?",
        options: [
          "JavaScript puro",
          "Uma biblioteca JavaScript",
          "Um framework JavaScript",
          "Um compilador de JavaScript",
        ],
        answer: "JavaScript puro",
      },
      {
        question: "Qual método usado para transformar numeros em string?",
        options: [
          "toNumber-ForString()",
          "String()(Number)",
          "toString()",
          "numberTo()(String)",
        ],
        answer: "toString()",
      },
      {
        question: "Qual método e usado para definir o numero de casas decimais?",
        options: [
          ".FixedTo()",
          ".ToFixed",
          "Fixed()",
          ".toFixed()",
        ],
        answer: ".toFixed()",
      },
      {
        question: "Assinale a alternativa mais correta a respeito da funcão setTimeout?",
        options: [
          "Executa um trecho de código de tempo em tempo",
          "Executa uma função ao iniciar o app",
          "Executa um código após um tempo, uma única vez",
          "Executa o código a cada 5 segundos",
        ],
        answer: "Executa um código após um tempo, uma única vez",
      },
      {
        question: "Com qual instrução declaramos uma constante em JavaScript?",
        options: ["const", "let", "var", "define"],
        answer: "const",
      },
      {
        question: "Qual dos tipos de dado a seguir não existe em JavaScript?",
        options: ["string", "number", "boolean", "float"],
        answer: "float",
      },
      {
        question: "Qual dos métodos a seguir seleciona um elemento?",
        options: ["querySelector", "parseInt", "sort", "reduce"],
        answer: "querySelector",
      },
      {
        question:
          "Qual destas propriedades da a quantidade de elementos de um array?",
        options: ["qty", "length", "items", "index"],
        answer: "length",
      },
      {
        question:
          "Qual comando usado para identificar qual e o tipo da variavel",
        options: ["TypeOf", "lengthOf", "typeof", "TYPEOF"],
        answer: "typeof",
      },
      {
        question:
          "Qual método utilizado para converter todas a letras em maiúsculas?",
        options: ["lowercase", " uppercase", "capitalize", "UpperCase"],
        answer: " uppercase",
      },
    ],
  },
  {
    category: "React",
    img: react,
    questions: [
      {
        question:
          "Qual hook pode ser usado para espalhar globalmente um estado",
        options: ["useState", "useRef", "useEffect", "useContext"],
        answer: "useContext",
      },
      {
        question:
          "Hook usado para modificar estados",
        options: ["useState", "useRef", "useEffect", "useContext"],
        answer: "useState",
      },
      {
        question:
          "Qual hook pode ser usado para gerenciar estados",
        options: ["useState", "useRef", "useReducer", "useContext"],
        answer: "useReducer",
      },
      {
        question:
          " Quando lançado, o ReactJS se destacou pela sua performance em comparação a soluções concorrentes. O que foi utilizado no React para ganhos de performance?",
        options: ["DOM", "Virtual DOM", "Service workers", "Nenhuma das alternativas"],
        answer: "Virtual DOM",
      },
      {
        question:
          "Qual hook deve ser utilizado para fazer request a uma API logo que o component é renderizado?",
        options: ["React.useFetch para carregar dados", "React.useAPI", "React.useEffect", " React.useComponentDidMount"],
        answer: "React.useEffect",
      },
      {
        question:
          "Em qual dos casos abaixo é aconselhável o uso da Context API do React?",
        options: ["Preciso passar dados de um componente pai para um componente filho", "Preciso compartilhar dados entre dois componentes irmãos", "Preciso compartilhar dados entre vários componentes que estão distantes um dos outros na árvore de componentes", "Preciso carregar dados de uma API"],
        answer: "Preciso compartilhar dados entre vários componentes que estão distantes um dos outros na árvore de componentes",
      },
      {
        question:
          "Qual método é utilizado para iniciar uma aplicação React?",
        options: ["ReactDOM.init()", "ReactDOM.render()", "React.render()", "React.start()"],
        answer: "ReactDOM.render()",
      },
      {
        question:
          "Para declararmos código no componente JSX, o que devemos utilizar?",
        options: ["{}", "()", "({})", "('')"],
        answer: "{}",
      },
      {
        question:
          "Sobre React Router Dom, qual das alternativas a baixo, e uma de suas funcões?",
        options: ["Implementar rotas de navegação", "Implementar componentes", "Tornar um componente mais rapido", "Implementar rotas do backend"],
        answer: "Implementar rotas de navegação",
      },
      {
        question:
          "Qual a função do .gitignore?",
        options: ["Criar novos components", "Criar componentes duplicados", "Ignorar componentes", "nda"],
        answer: "Ignorar componentes",
      },
    ],
  },
  {
    category: "Python",
    img: python,
    questions: [
      {
        question:
          "Qual dos codigos abaixo representa corretamente a escrita,  de olá mundo",
        options: ["console.log('Hello World')", "Serial.println('Hello, world!')", "System.Console.WriteLine('Hello, World!')", "print('Hello World')"],
        answer: "print('Hello World')",
      },
      {
        question:
          "Qual é a saída do código a seguir? : x = 36 / 4 * (3 +  2) * 4 + 2 print(x)",
        options: ["37.0", "182.0", "172.0", "117.0"],
        answer: "182.0",
      },
      {
        question:
          "Qual operador tem maior precedência na lista a seguir: var = 'James' * 2  * 3 print(var)",
        options: ["JamesJamesJamesJamesJames", "JamesJamesJamesJamesJamesJames", "Error: invalid syntax", "nda"],
        answer: "JamesJamesJamesJamesJamesJames",
      },
      {
        question:
          "Qual operador lógico utilizado para verificar de dois valores são diferentes?",
        options: ["==", "#", "!=", ">="],
        answer: "!=",
      },
      {
        question:
          "É uma biblioteca da linguagem Python que permite desenvolver interfaces gráficas?",
        options: ["XWindow", "WxWidgets", "SxWidget", "Tkinter"],
        answer: "Tkinter",
      },
      {
        question:
          "Qual dos métodos abaixo usamos para receber algum dado do usuário através do CLI?",
        options: ["print()", "input()", "scanf()", "prompt()"],
        answer: "input()",
      },
      {
        question:
          "Qual a forma correta para importar o método pi módulo math em seu script?",
        options: ["import math from pi", "Simport pi", "from pi", "from math import pi"],
        answer: "from math import pi",
      },
      {
        question:
          "Como criar uma lista com números de 1 a 5?",
        options: ["lista = num(1, 5)", "lista = {1, 2, 3, 4, 5}", "lista = (1, 2, 3, 4, 5)", "lista = [1, 2, 3, 4, 5]"],
        answer: "lista = [1, 2, 3, 4, 5]",
      },
      {
        question:
          "Qual dos codigos abaixo representa corretamente a escrita,  de olá mundo",
        options: ["console.log('Hello World')", "Serial.println('Hello, world!')", "System.Console.WriteLine('Hello, World!')", "print('Hello World')"],
        answer: "print('Hello World')",
      },
      {
        question:
          "Como abrir um arquivo como leitura?",
        options: ["open(nome_arquivo,'r')", "open(nome_arquivo,'w')", "open(nome_arquivo,'a')", "open(nome_arquivo,'a+'')"],
        answer: "open(nome_arquivo,'r')",
      }
    ],
  },
  {
    category: "Java",
    img: java,
    questions: [
      {
        question:
          "Java e uma...",
        options: ["Linguagem de alto nível", "linguagem de programação funcional, imperativa e reflexiva", "Linguagem orientada a objetos", "Todas estão corretas"],
        answer: "Todas estão corretas",
      },
      {
        question:
          "Java e projetado por?",
        options: ["Charles Babbage", "James Gosling", "Guido van Rossum", "charlie chaplin"],
        answer: "James Gosling",
      },
      {
        question:
          "Qual é o valor padrão do tipo de dados boolean em Java?",
        options: ["1", "0", "true", "false"],
        answer: "false",
      },

      {
        question:
          "Na linguagem Java, a palavra-chave que deve ser usada para especificar que uma variável não pode ser modificada é",
        options: ["static", "final", "conts", "constante"],
        answer: "final",
      },
      {
        question:
          "Na hierarquia de exceções em Java, é correto afirmar que",
        options: ["a classe RuntimeException é uma subclasse da classe Exception.", "a classe Error herda da classe Exception.", " as classes NullPointerException e IndexOutOfBoundsException não são válidas no tratamento de exceção em Java", "a classe Exception é uma subclasse da classe IOException."],
        answer: "a classe RuntimeException é uma subclasse da classe Exception.",
      },
      {
        question:
          "As classes Java a seguir pertencem ao pacote default e foram incluídas no arquivo Main.java. class MnopA {      static int x=10,y=10,z=10;      public MnopA() {         x*=2;      }      {          y+=5;          z+=10;      } } class MnopB extends MnopA {     public MnopB(int c) {          y*=c;      }     {      z+=y;      }      static {          x=y=z=1;      } } public class Main {      public static void main(String [ ] args) {          MnopB o=new MnopB(2);          System.out.println(MnopB.x+MnopB.y+MnopB.z);      } } O que será exibido no console quando o método main for executado?",
        options: ["3", "4", "19", "31"],
        answer: "31",
      },
      {
        question:
          "Na camada de apresentação do Java EE 8, o uso de um gerente central que trata todos os pedidos (requests), ou um grupo de pedidos, para uma aplicação e os envia para um processo específico, é conhecido como",
        options: ["Abstract Command", "Command", "Data Access Object", "Front Controller"],
        answer: "Front Controller",
      },
      {
        question:
          "Em relação ao ciclo de vida e aos estados de thread na linguagem Java, é INCORRETO afirmar que uma thread",
        options: ["executável entra no estado terminado somente quando ela conclui com sucesso suas tarefas.", "executável pode entrar no estado de espera sincronizada por um intervalo especificado de tempo.", "em espera volta ao estado executável somente quando outra thread a notifica para continuar a execução.", " no estado novo permanece nesse estado até que o programa inicie a thread, o que a coloca no estado executável."],
        answer: "executável entra no estado terminado somente quando ela conclui com sucesso suas tarefas.",
      },
      {
        question:
          "A alternativa que contém apenas operadores válidos na linguagem Java é",
        options: ["+, ==, <> e %.", " -, :=, != e /.", "*, <=, ** e >.", "/, !=, >= e *."],
        answer: "/, !=, >= e *.",
      },
      {
        question:
          "Java é uma plataforma de software que possibilita a um mesmo programa ser executado em diversas plataformas. Os códigos gerados no processo de compilação, específicos a qualquer máquina física, são instruções para uma máquina virtual. Um programa escrito em linguagem Java é compilado e gera um arquivo .class, que pode ser executado onde quer que a plataforma Java esteja presente, em qualquer sistema operacional subjacente. Nesse contexto, esse arquivo .class é conhecido por",
        options: [" microcode", "macrocode", "bytecode", "bitcode"],
        answer: "bytecode",
      },
    ],
  },
  {
    category: "C#",
    img: c,
    questions: [
      {
        question:
          "O código escrito para o .NET Framework é denominado código gerenciado. Ele é escrito em linguagens como Visual C# e Visual Basic. Ele se diferencia do código nativo tradicional porque",
        options: ["ele é escrito em código de máquina e compilado no Intermediate Language (IL) antes de ser executado.", "primeiramente ele precisa ser executado para depois gerar código de máquina.", "ele é compilado no Intermediate Language (IL) e depois traduzido em código de máquina antes de ser executado.", "ele não precisa ser compilado porque é escrito nativamente para o .NET Frameworl"],
        answer: "ele é compilado no Intermediate Language (IL) e depois traduzido em código de máquina antes de ser executado.",
      },
      {
        question:
          "Fornece códigos testados e reutilizáveis para os desenvolvedores utilizarem à partir de seus próprios aplicativos, facilitam o processo de desenvolvimento e fornecem acesso a funções essenciais do sistema. Essa funcionalidade refere-se",
        options: ["ao Visual Studio", "ao IL - Intermediate Language", "ao CLR - Common Language Runtime", "à Class Library - Biblioteca de classes"],
        answer: "à Class Library - Biblioteca de classes",
      },
      {
        question:
          "Analise as afirmações a seguir sobre a Linguagem de Programação C#. I. A linguagem C# NÃO é case sensitive, ou seja, não faz distinção entre letras maiúsculas e minúsculas. II. C# é uma linguagem de programação orientada a objeto. III. C# é uma linguagem de programação orientada a eventos. IV. C# foi projetada especificamente para a plataforma .NET É correto apenas o que se afirma em",
        options: ["I e II", "I e III", "II, III e IV", "I e IV"],
        answer: "II, III e IV",
      },
      {
        question:
          "De acordo com as regras para nomeação e declaração de variáveis, selecione a alternativa correta que contém a declaração INVÁLIDA.",
        options: ["float tempo de percurso", "int numeros", "decimal salario_mensal", "bool clienteAtivo"],
        answer: "float tempo de percurso",
      },
      {
        question:
          "Quando declaramos variáveis, devemos informar o seu tipo e o identificador (nome). O tipo de dados char armazena",
        options: ["uma string.", "um caractere", "números sem casas decimais", "valores true ou false"],
        answer: "um caractere",
      },
      {
        question:
          "As variáveis possuem tipos de dados diferentes e frequentemente precisamos fazer conversões entre tipos de dados. Selecione a alternativa correta referente aos tipos de conversão de dados da linguagem C#.",
        options: ["Conversão explícita e textual.", "Conversão implícita e inteira.", "Conversão implícita e explícita.", "Conversão estática e dinâmica."],
        answer: "Conversão implícita e explícita.",
      },
      {
        question:
          "Toda instrução deve terminar com um terminador de instrução que é o ponto-e-vírgula ( ; ). Quando esse terminador é omitido, o compliador não reconhece a instrução porque ocorreu um erro. Que tipo de erro o compilador aponta?",
        options: ["Erro lógico.", "Erro de sintaxe", "Erro em tempo de execução", "Erro de compilação."],
        answer: "Erro de sintaxe",
      },
      {
        question:
          "Qual linguagem não é uma verdadeira linguagem de programação orientada a objetos?",
        options: ["VB.NET", "JAVA", "C#", "C++"],
        answer: "C++",
      },
      {
        question:
          "Quais componentes do .NET podem ser usados ​​para remover referências não utilizadas do heap gerenciado?",
        options: ["Garbage Collector", "CLR", "Common Language Infrastructure", "Class Loader"],
        answer: "Garbage Collector",
      },
      {
        question:
          "Qual dos seguintes é o namespace base na biblioteca de classes do .NET Framework?",
        options: ["System", "System.IO", "System.Base", "Object"],
        answer: "System",
      }
    ],
  },
  {
    category: "Github",
    img: git,
    questions: [
      {
        question:
          "Qual comando usado para atribuir globalmente um usuário a conta git?",
        options: ["git config --globall user.name", "git config --globall name", "git config --globall user@name", "git config --globall @name"],
        answer: "git config --globall user.name",
      },
      {
        question:
          "Qual comando gera um clone apenas dos arquivos de um repositório",
        options: ["git clone + 'url' + '.' ", "git clone + url", "git clone + url + url", "git clone + '.' "],
        answer: "git clone + 'url' + '.' ",
      },
      {
        question:
          "O que faz o comando git branch + 'nome do arquivo'?",
        options: ["irá mostrar a branch existente", "duplica a branch", "cria uma nova branch", "nenhuma das alternativas"],
        answer: "cria uma nova branch",
      },
      {
        question:
          "Qual comando usado para receber as alterações de uma branch no github?",
        options: ["git pool", "git init pull", "pull git init", "git pull"],
        answer: "git pull",
      },
      {
        question:
          "Qual comando usado para unir uma branch criada a branch main?",
        options: ["git MERGER", "git merge", "git init merge", "merger git"],
        answer: "git merge",
      },
      {
        question:
          "Qual comando usado para verificar estado no git?",
        options: ["git status", "git STATUS", "git show status", "git show"],
        answer: "git status",
      },
      {
        question:
          "Qual comando usado para iniciar um repositorio git?",
        options: ["git INIT", "git .init", "git init", "git show init"],
        answer: "git init",
      },
      {
        question:
          "O que faz o comando git fetch -a?",
        options: ["Busca novas branch criadas por outros dev no projeto", "Busca a ultima branch do projeto criada", "Junta todas as branch do projeto", "nda"],
        answer: "Busca novas branch criadas por outros dev no projeto",
      },
      {
        question:
          "Qual e a licença mais utilizada nos projetos?",
        options: ["git license", "Free license", "Mit license", "Row license"],
        answer: "Mit license",
      },
      {
        question:
          "O que faz o comando git add .?",
        options: ["adicona o primeiro arquivo do projeto", "adiciona 1 arquivo do projeto", "adicionar todos os arquivos do projeto", "nda"],
        answer: "adicionar todos os arquivos do projeto",
      },

    ],
  },

];

export default data;
